import { render, staticRenderFns } from "./alarmFace.vue?vue&type=template&id=63cbe1de&scoped=true&"
import script from "./alarmFace.vue?vue&type=script&lang=js&"
export * from "./alarmFace.vue?vue&type=script&lang=js&"
import style0 from "./alarmFace.vue?vue&type=style&index=0&id=63cbe1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cbe1de",
  null
  
)

export default component.exports